<template>
    <div class="inline-flex items-center justify-center px-2 h-5 text-sm font-normal rounded min-w-[3rem] uppercase border-2 border-white"
         :class="{
            'bg-primary-gray-800': disabled,
            'bg-primary': !disabled && !bgColor,
            'text-white': disabled || !textColor
        }"
         :style="{
            backgroundColor: !disabled && bgColor ? `#${bgColor}` : null,
            color: !disabled && textColor ? `#${textColor}` : null,
        }"
    >
        {{ route.shortName ?? route.id }}
    </div>
</template>

<script>
import {defineComponent, ref, watch} from 'vue';
import {useRouteStore} from "../stores/routes";

export default defineComponent({
    name: 'Tag',

    props: {
        route: { type: Object, required: true },
        disabled: { type: Boolean, required: false, default: false },
    },

    setup(props) {
        const routeStore = useRouteStore();
        const {route} = props;
        let routeColorData = routeStore.configureRouteColorData(route);

        const bgColor = ref(routeColorData.color);
        const textColor = ref(routeColorData.textColor);

        watch(() => props.route, (newValue) => {
            routeColorData = routeStore.configureRouteColorData(newValue);
            bgColor.value = routeColorData.color;
            textColor.value = routeColorData.textColor;
        })

        return {
            bgColor,
            textColor
        }
    },
});
</script>
